import {
  Card,
  DisplayText,
  EmptyState,
  Form,
  FormLayout,
  Layout,
  Modal,
  Page,
  PageActions,
  RadioButton,
  Select,
  SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonPage,
  Stack,
  TextContainer,
  TextField,
  Toast,
} from "@shopify/polaris";
import { useCallback, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../config/store";

import emptyIMG from "../../media/empty.png";
import { clearError, getEntity, updateEntity, deleteEntity, createEntity, reset } from "../../store/city.store.reducer";
import { lengthLessThan, lengthMoreThan, useField, useForm, notEmpty } from "@shopify/react-form";
import helpers from "helpers";
import countriesData from "components/countryData";
import QuickUploadImage from "components/oneclick-upload";
import uploadimage from "../../media/choose-file.png";

export default function Edit_city() {
  const entity = useAppSelector((state) => state.city.entity);
  const updating = useAppSelector((state) => state.city.updating);
  const entities = useAppSelector((state) => state.city.entities);
  const loading = useAppSelector((state) => state.city.loading);
  const errorMessage = useAppSelector((state) => state.city.errorMessage);
  const updateSuccess = useAppSelector((state) => state.city.updateSuccess);

  const dispatch = useAppDispatch();
  const history = useNavigate();

  // jamviet.com
  const [message, setMessage] = useState(null);

  const [openModal, setOpenModal] = useState(false);

  const [notification, setNotification] = useState(null);

  const toggleActive = useCallback(() => {
    setMessage(null);
    dispatch(clearError());
  }, []);

  let useParam = {} as any;
  useParam = useParams();
  let Param = useParam.city_slug || false;

  useEffect(() => {
    if (Param) dispatch(getEntity(Param));
    else dispatch(reset());
  }, []);

  /**
   * Option type
   */

  const [capital, setCapital] = useState("primary");

  const method = [
    { label: "primary", value: "primary" },
    { label: "admin", value: "admin" },
  ];

  const handleSelectChange = useCallback((value) => setCapital(value), []);

  /**
   * Country
   */

  const [country_selected, setCountry_selected] = useState("");
  const option_country = countriesData?.countriesData;

  const changeHandler = (value) => {
    setCountry_selected(value);
  };

  /**
   * Upload image
   */
  const [srcImage, setSrcImage] = useState(uploadimage);

  const [internalErrorNotice, setInternalErrorNotice] = useState("");

  useEffect(() => {
    if (entity) {
      if (Param) {
        setSrcImage(entity?.avatar);

        setCapital(entity?.capital);
        setCountry_selected(entity?.country_iso2?.toLowerCase());
      } else {
        setSrcImage(uploadimage);

        setCapital("primary");
        setCountry_selected("");
      }
    }
  }, [entity]);

  function handQuickUpdateSuccess(res: any) {
    let media_root = process.env.REACT_APP_AJAX_UPLOAD_IMAGE;
    console.log(media_root, "dsfdsf");
    setSrcImage(media_root + "" + res.media_file_name);
  }

  function handUploadError(err: any) {
    setInternalErrorNotice("Upload Fail! Image is too large!");
  }

  useEffect(() => {
    if (updateSuccess) {
      history("/city/edit/" + entity?._id, {
        replace: true,
      });

      setNotification("This city has been updated!");
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (errorMessage) {
      setNotification(errorMessage);
      dispatch(clearError());
    }
  }, [errorMessage]);

  function _deleteEntityAction() {
    setOpenModal(true);
  }

  function onModalAgree() {
    dispatch(deleteEntity(Param));
    setOpenModal(false);
  }

  const useFields = {
    city_name: useField<string>({
      value: entity?.city_name ?? "",
      validates: [
        lengthLessThan(250, "No more than 250 characters."),
        lengthMoreThan(6, "No shorter than 6 characters."),
        (inputValue) => {
          if (inputValue.length < 6) {
            return "Your title is too short, or it is empty.";
          }
        },
      ],
    }),

    city_ascii: useField<string>({
      value: entity?.city_ascii ?? "",
      validates: [
        lengthLessThan(250, "No more than 250 characters."),
        lengthMoreThan(6, "No shorter than 6 characters."),
        (inputValue) => {
          if (inputValue.length < 6) {
            return "Your title is too short, or it is empty.";
          }
        },
      ],
    }),
  };

  const {
    fields,
    submit,
    submitting,
    dirty,
    reset: Userreset,
    submitErrors,
    makeClean,
  } = useForm({
    fields: useFields,
    async onSubmit(values) {
      try {
        if (!Param) {
          // create new
          dispatch(
            createEntity({
              city_name: values.city_name,
              city_ascii: values.city_ascii,
              capital: capital,
              // country:
            })
          );
        } else {
          dispatch(
            updateEntity({
              _id: entity._id,
              city_name: values.city_name,
              city_ascii: values.city_ascii,
              capital: capital,
            })
          );
        }
        return { status: "success" };
      } catch (e: any) {
        console.error(`Submit error`, e);
        const message = e?.response?.data?.title ?? "Lỗi không xác định, vui lòng thử lại sau.";
        const field = e?.response?.data?.errorKey ?? "base";
        return { status: "fail", errors: [{ field, message }] };
      }
    },
  });

  const emptyData = (
    <Page title="City" breadcrumbs={[{ content: "City list", url: "/city" }]}>
      <EmptyState heading="No post here!" image={emptyIMG}>
        <p>This record maybe not exist!</p>
      </EmptyState>
    </Page>
  );

  const toastMarkup = notification ? <Toast content={notification} onDismiss={toggleActive} /> : null;

  const toastNotification = message ? <Toast content={message} onDismiss={toggleActive} /> : null;

  const Actual_page =
    entity || !Param ? (
      <>
        <Page
          title="City"
          breadcrumbs={[{ content: "City list", url: "/city" }]}
          primaryAction={{
            content: "Save",
            disabled: !dirty,
            loading: updating,
            onAction: submit,
          }}
        >
          <Layout>
            <Layout.Section>
              <Form onSubmit={submit}>
                <Card>
                  <Card.Section>
                    <FormLayout>
                      <DisplayText size="small">Image</DisplayText>
                      {/* <div id="profile_heading">
                        <div className="banner_thumbnail_inner">
                          <div className="banner_thumbnail_avatar">
                            <QuickUploadImage onSuccess={handQuickUpdateSuccess} onError={handUploadError} />
                            <img
                              src={srcImage}
                              crossOrigin="anonymous"
                              // alt="Upload banner here"
                              style={{ width: "115px" }}
                            />
                          </div>
                        </div>
                      </div> */}

                      <div className="news_thumbnail_inner">
                        <div className="news_thumbnail_avatar">
                          <img src={srcImage} style={{ width: "115px" }} />
                        </div>
                      </div>

                      <TextField
                        autoComplete="off"
                        maxLength={1000}
                        requiredIndicator
                        label="City Name"
                        {...fields.city_name}
                      />

                      <TextField
                        autoComplete="off"
                        maxLength={1000}
                        requiredIndicator
                        label="City Ascii"
                        {...fields.city_ascii}
                      />

                      <Select
                        label="Capital"
                        options={method}
                        requiredIndicator
                        onChange={handleSelectChange}
                        value={capital}
                      />

                      <Select
                        label="Country"
                        options={option_country}
                        onChange={changeHandler}
                        value={country_selected}
                        disabled={true}
                      />
                    </FormLayout>
                  </Card.Section>
                </Card>
              </Form>
            </Layout.Section>
          </Layout>
          <PageActions
            primaryAction={{
              content: "Save",
              onAction: submit,
              disabled: !dirty,
              loading: updating,
            }}
            secondaryActions={
              Param
                ? [
                    {
                      content: "Delete",
                      destructive: true,
                      onAction: _deleteEntityAction,
                    },
                  ]
                : []
            }
          />
        </Page>
      </>
    ) : (
      emptyData
    );

  const skeleton_loading = (
    <SkeletonPage primaryAction>
      <Layout>
        <Layout.Section>
          <Card sectioned>
            <SkeletonBodyText />
          </Card>
          <Card sectioned>
            <TextContainer>
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText />
            </TextContainer>
          </Card>
          <Card sectioned>
            <TextContainer>
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText />
            </TextContainer>
          </Card>
        </Layout.Section>
        <Layout.Section secondary>
          <Card>
            <Card.Section>
              <TextContainer>
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={2} />
              </TextContainer>
            </Card.Section>
            <Card.Section>
              <SkeletonBodyText lines={1} />
            </Card.Section>
          </Card>
          <Card subdued>
            <Card.Section>
              <TextContainer>
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={2} />
              </TextContainer>
            </Card.Section>
            <Card.Section>
              <SkeletonBodyText lines={2} />
            </Card.Section>
          </Card>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );

  const _Modal = openModal ? (
    <Modal
      activator={null}
      open={true}
      onClose={() => setOpenModal(false)}
      title="Delete entity?"
      primaryAction={{
        content: "Delete",
        onAction: onModalAgree,
      }}
      secondaryActions={[
        {
          content: "Cancel",
          onAction: () => {
            setOpenModal(false);
          },
        },
      ]}
    >
      <Modal.Section>
        <TextContainer>
          <p>After delete, you can not undo this action!</p>
        </TextContainer>
      </Modal.Section>
    </Modal>
  ) : null;

  return (
    <>
      {_Modal}
      {toastMarkup}
      {toastNotification}
      {loading ? skeleton_loading : Actual_page}
    </>
  );
}

